import { render, staticRenderFns } from "./TanaguruTestImport.vue?vue&type=template&id=b4904756&"
import script from "./TanaguruTestImport.vue?vue&type=script&lang=js&"
export * from "./TanaguruTestImport.vue?vue&type=script&lang=js&"
import style0 from "./TanaguruTestImport.vue?vue&type=style&index=0&id=b4904756&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports